module.exports = __webpack_public_path__ + "static/media/status-sent.18ebfc4e.svg";